import { Container } from "@components/wrapper"
import { VideoTestimonies } from "@interfaces/school"
import clsx from "clsx"
import React, { useEffect, useState } from "react"
import Carousel, { DotProps } from "react-multi-carousel"
// import { BootcampSliderArrow } from "."
import { VideoTestimony } from "@components/video/VideoTestimony"
import { BootcampSliderArrow } from "@modules/program/components/bootcamp"
import TestimonyShortPlayer from "@components/video/TestimonyShortPlayer"

const CustomDot = ({ active, onClick }: DotProps) => {
  return (
    <button
      className={clsx(
        "wh-3 rounded-full mx-1.5 border-0 transition-all duration-200",
        active ? "bg-blue" : "bg-grey-c4 w-auto rounded-0"
      )}
      onClick={(e) => {
        if (onClick) {
          onClick()
        }
        e.preventDefault()
      }}
    />
  )
}

const TestimonyVideo = ({
  testimonies,
  screenWidth,
}: {
  testimonies: VideoTestimonies[]
  screenWidth: number
}) => {
  const [indexPlayed, setIndexPlayed] = useState(-1)

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  const videoToggler = (index: number) => () => {
    console.log("clicked")
    setIndexPlayed(index)
  }

  if (!testimonies.length) {
    return <></>
  }

  const youtubeOnly = testimonies.filter((d) => d.video.video_url.includes("youtube"))

  if (!youtubeOnly.length) {
    return <></>
  }

  return (
    <div className="bg-[#101820] sm:py-20 py-10">
      <Container className="relative">
        <h3
          className={clsx(
            "font-urbanist sm:text-[32px] text-white font-semibold mb-3 text-center",
            "text-2xl"
          )}
        >
          Simak Cerita Sukses Alumni Harisenin.com
        </h3>
        <div className="relative sm:gap-15 gap-4.5 sm:flex grid">
          <div className="sm:w-full">
            <div className="sm-only:w-[90vw]">
              <Carousel
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                containerClass={clsx("sm:-ml-4 sm:py-5 px-0 gap-5 sm-only:-mx-2.5")}
                itemClass="sm-only:mb-5"
                arrows={false}
                showDots={screenWidth < 576 && youtubeOnly.length > 1}
                {...(screenWidth > 576 && {
                  customButtonGroup: (
                    <BootcampSliderArrow
                      displayedSlide={5}
                      length={testimonies.length}
                      className="gap-6 justify-center"
                    />
                  ),
                  renderButtonGroupOutside: true,
                })}
                {...(screenWidth < 576 && {
                  customDot: <CustomDot />,
                  renderDotsOutside: true,
                  dotListClass: "!-bottom-3",
                  // autoPlay: true,
                  // infinite: true,
                  autoPlaySpeed: 3000,
                })}
              >
                {youtubeOnly.map((value, i) => (
                  <TestimonyShortPlayer
                    className="px-2"
                    testimonial={value}
                    isPlayed={indexPlayed === i}
                    onClick={videoToggler(i)}
                    key={i}
                    playerHeight="sm:h-[29vw] h-[159vw]"
                  />
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default TestimonyVideo
